import useShouldRenderCondensedHero from '~/hooks/vdp/useShouldRenderCondensedHero';
import useShouldShowMiniHeroDesktop from '~/hooks/vdp/useShouldShowMiniHeroDesktop';

export default function useShowMiniHeroInfoCard() {
  const shouldShowMiniHeroDesktop = useShouldShowMiniHeroDesktop();
  const renderCondensedHero = useShouldRenderCondensedHero();

  return shouldShowMiniHeroDesktop && renderCondensedHero;
}
